import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const OnboardingPage = Loadable(lazy(() => import('pages/aegis/onboarding')));
const ProjectPage = Loadable(lazy(() => import('pages/aegis/projects')));
const TargetPage = Loadable(lazy(() => import('pages/aegis/targets')));
const MemberPage = Loadable(lazy(() => import('pages/aegis/members')));
const NewScanPage = Loadable(lazy(() => import('pages/aegis/new-scan')));
const RunningScansPage = Loadable(lazy(() => import('pages/aegis/running-scans')));
const ScanHistoryPage = Loadable(lazy(() => import('pages/aegis/scan-history')));
const FindingsPage = Loadable(lazy(() => import('pages/aegis/findings')));
const FindingPrioritiesPage = Loadable(lazy(() => import('pages/aegis/finding-priorities')));
const AiAnalysisPage = Loadable(lazy(() => import('pages/aegis/ai-analysis')));
const CustomerReportPage = Loadable(lazy(() => import('pages/aegis/customer-report')));
const RecheckReportPage = Loadable(lazy(() => import('pages/aegis/recheck-report')));
const AuditLogsPage = Loadable(lazy(() => import('pages/aegis/audit-logs')));
const BillingPage = Loadable(lazy(() => import('pages/aegis/billing')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'onboarding',
      element: <OnboardingPage />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
        {
          path: 'security',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'projects',
      element: <ProjectPage />
    },
    {
      path: 'projects/targets',
      element: <TargetPage />
    },
    {
      path: 'projects/members',
      element: <MemberPage />
    },
    {
      path: 'scans/new',
      element: <NewScanPage />
    },
    {
      path: 'scans/running',
      element: <RunningScansPage />
    },
    {
      path: 'scans/history',
      element: <ScanHistoryPage />
    },
    {
      path: 'findings',
      element: <FindingsPage />
    },
    {
      path: 'findings/priorities',
      element: <FindingPrioritiesPage />
    },
    {
      path: 'ai/analysis',
      element: <AiAnalysisPage />
    },
    {
      path: 'ai/fix-guide',
      element: <AiAnalysisPage />
    },
    {
      path: 'reports',
      element: <CustomerReportPage />
    },
    {
      path: 'reports/customer',
      element: <CustomerReportPage />
    },
    {
      path: 'reports/recheck',
      element: <RecheckReportPage />
    },
    {
      path: 'settings/audit-logs',
      element: <AuditLogsPage />
    },
    {
      path: 'settings/billing',
      element: <BillingPage />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: '*',
      element: <SamplePage />
    }
  ]
};

export default MainRoutes;
